import React from 'react';
import { Col, Row } from 'antd';
import * as etiquetas from '../../../ApplicationResources';
import { selectDistrito, selectProceso, selectRutaPublicador } from '../../../redux/menu/menu-selectors';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import iconRegistro from "../../../img/registra_icon.svg";
import iconReporte from "../../../img/reporte_icon.svg";
import iconValidar from "../../../img/validar_icon.svg";
import iconAdministracion from "../../../img/icons/administracion.svg";
import { withRouter } from 'react-router-dom';
import { selectCurrentUser } from '../../../redux/user/user-selectors';

class Menu extends React.Component {
    procesoSeleccionado = () => {
        const {proceso} = this.props;
        const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
        const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

        if(idProcesoElectoral > 0 && idDetalleProceso > 0)
          return true;
        return false;
    }

    distritoProcesoSeleccionado = () => {
        const { proceso, selectDistrito } = this.props;
        const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
        const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
        const idDistrito = selectDistrito ? selectDistrito.idDistrito : 0;

        if(idProcesoElectoral > 0 && idDetalleProceso > 0 && idDistrito > 0)
            return true;
        return false;
    }

    // Función que valida si estamos en el módulo de bandeja
    moduloBandeja = () => {
        if(window.location.pathname === '/bandeja')
            return true;
        return false;
    }

    moduloJuntaEjecutiva = () => {
        if(window.location.pathname === '/juntaEjecutiva')
            return true;
        return false;
    }

    moduloRegistroAspirante = () => {
        if(window.location.pathname === '/registro_aspirante')
            return true;
        return false;
    }

    onRegistroAspirante = () => {
        this.props.history.push('/registro_aspirante');

    }

    onBandeja = () => {
      this.props.history.push('/bandeja');
    }

    onJuntaEjecutiva = () => {
        this.props.history.push('/juntaEjecutiva');
    }

    onPublicador = () => {
        const win = window.open(this.props.rutaPublicador, '_blank');
        if (win != null) {
          win.focus();
        }
    }

    render() {
        // Indica si el rol de usuario tiene permiso de captura o no (true / false)
        const permisoCaptura = etiquetas.rolesCaptura.includes(this.props.datosUsuario.rolUsuario);
        // Indica si el rol del usuario tiene permiso de administrador o no (true / false)
        const permisoAdministrador = etiquetas.rolesAdmin.includes(this.props.datosUsuario.rolUsuario);

        // Tamaño de las columnas cuando no se mostrará la opción de juntas ejecutivas
        var tamanioColumnas = 5;
        var offsetColumnas = 5;
        var tamanioColumnasPrincipal = 24;

        if(permisoAdministrador) {
            // Tamaño de las columnas cuando se mostrará la opción de juntas ejecutivas
            tamanioColumnas = 5;
            offsetColumnas = 4;
            tamanioColumnasPrincipal = 20;
        }

        return(
            <div id="options-menu">
                <Col xs={tamanioColumnasPrincipal} sm={tamanioColumnasPrincipal} md={tamanioColumnasPrincipal} lg={tamanioColumnasPrincipal} offset={offsetColumnas}>
                    {
                        permisoAdministrador ? 
                            <Col xs={tamanioColumnas} sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}>
                                <div className="element_option_menu_recluta" id="validar-recluta">
                                    <a onClick={this.onJuntaEjecutiva} className="btn btn-success mr-2" disabled={!this.distritoProcesoSeleccionado() || this.moduloJuntaEjecutiva()}>
                                        <Col xs={24} sm={24} md={24} lg={6} className="columna_imagen_menu_recluta">
                                            <img src={iconAdministracion} className={this.distritoProcesoSeleccionado() && !this.moduloJuntaEjecutiva() ? "" : "imagen_deshabilitada"} />
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={18} className="columna_texto_menu_recluta">
                                            <span className={this.distritoProcesoSeleccionado() && !this.moduloJuntaEjecutiva() ? "label_lement_menu-habilitado" : "label_lement_menu_deshabilitado"}
                                                    id="validar-label">
                                                {etiquetas.menu_element_junta_ejecutiva}
                                            </span>
                                        </Col>
                                    </a>
                                </div>
                            </Col> :
                        ""
                    }

                    <Col xs={tamanioColumnas} sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}>
                        <div className="element_option_menu_recluta" id="validar-recluta">
                            <a onClick={this.onBandeja} className="btn btn-success mr-2" disabled={!this.procesoSeleccionado() || this.moduloBandeja()}>
                                <Col xs={24} sm={24} md={24} lg={6} className="columna_imagen_menu_recluta">
                                    <img src={iconValidar} className={this.procesoSeleccionado() && !this.moduloBandeja() ? "" : "imagen_deshabilitada"} />
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={18} className="columna_texto_menu_recluta">
                                    <span className={this.procesoSeleccionado() && !this.moduloBandeja() ? "label_lement_menu-habilitado" : "label_lement_menu_deshabilitado"}
                                            id="validar-label">
                                        {etiquetas.menu_element_uno}
                                    </span>
                                </Col>
                            </a>
                        </div>
                    </Col>

                    <Col xs={tamanioColumnas} sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}>
                        <div className="element_option_menu_recluta" id="registro-recluta">
                            <a onClick={this.onRegistroAspirante} disabled={!this.procesoSeleccionado() || this.moduloRegistroAspirante() || !permisoCaptura}
                                    className="btn btn-success mr-2">
                                <Col xs={24} sm={24} md={24} lg={6} className="columna_imagen_menu_recluta">
                                    <img src={iconRegistro} className={this.procesoSeleccionado() && !this.moduloRegistroAspirante() && permisoCaptura ? "" : "imagen_deshabilitada"} />
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={18} className="columna_texto_menu_recluta">
                                    <span className={this.procesoSeleccionado() && !this.moduloRegistroAspirante() && permisoCaptura ? "label_lement_menu-habilitado" : "label_lement_menu_deshabilitado"} id="registro-label">
                                    {etiquetas.menu_element_dos}
                                    </span>
                                </Col>
                            </a>
                        </div>
                    </Col>
                    
                    <Col xs={tamanioColumnas} sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}>
                        <div className="element_option_menu_recluta" id="reportes-recluta">
                            <a onClick={this.onPublicador} disabled={!this.procesoSeleccionado()}
                                className="btn btn-success mr-2" target="_blank">
                                <Col xs={24} sm={24} md={24} lg={6} className="columna_imagen_menu_recluta">
                                <img src={iconReporte} className={this.procesoSeleccionado() ? "" : "imagen_deshabilitada"} />
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={18} className="columna_texto_menu_recluta">
                                    <span className={this.procesoSeleccionado() ? "label_lement_menu-habilitado" : "label_lement_menu_deshabilitado"} id="reporte-label">
                                        {etiquetas.menu_element_tres}
                                    </span>                          
                                </Col>
                            </a>
                        </div>
                    </Col>
                </Col>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    proceso: selectProceso,
    rutaPublicador: selectRutaPublicador,
    datosUsuario: selectCurrentUser,
    selectDistrito : selectDistrito
});

export default withRouter(connect(mapStateToProps)(Menu));